// src/components/CityFX/CityFX.jsx
// Fondo ambiental "cyberpunk ciudad nocturna pixel" para TODA la app (solo modo
// oscuro). Vive fijo detrás del contenido: estrellas + orbes neón + grilla
// synthwave + skyline pixel (reusa la ciudad del landing) + scanlines CRT.
// Sutil a propósito: las tarjetas opacas quedan legibles encima.
import React from 'react';
import cityImg from '../../assets/fx/city.png';
import starsImg from '../../assets/fx/stars.svg';
import './CityFX.css';

export default function CityFX() {
  // los assets se inyectan por variables CSS (webpack los empaqueta)
  const vars = { '--cfx-city': `url(${cityImg})`, '--cfx-stars': `url(${starsImg})` };
  return (
    <div className="city-fx" style={vars} aria-hidden="true">
      <div className="cfx-stars" />
      <div className="cfx-orb cfx-orb-1" />
      <div className="cfx-orb cfx-orb-2" />
      <div className="cfx-orb cfx-orb-3" />
      <div className="cfx-grid" />
      <div className="cfx-sunset" />
      <div className="cfx-skyline" />
      <div className="cfx-scan" />
    </div>
  );
}
